var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2444 1.15838L3.27773 6.91672L1.6944 5.22505C1.40273 4.95005 0.944401 4.93339 0.611067 5.16672C0.286067 5.40839 0.194401 5.83338 0.394401 6.17505L2.2694 9.22505C2.45273 9.50838 2.7694 9.68339 3.12773 9.68339C3.4694 9.68339 3.7944 9.50838 3.97773 9.22505C4.27773 8.83338 10.0027 2.00838 10.0027 2.00838C10.7527 1.24172 9.8444 0.566718 9.2444 1.15005V1.15838Z",
    fill: "#044448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.3dfcdb26839ca61a5870a9a1284564fc.svg";
export { ForwardRef as ReactComponent };